<template>
  <div class="form form-sad">
    <h5>{{ $t("message.contracts.document_sad") }}</h5>

    <!--
			This is a recursive component to render form inputs according to
			the field list.
			Current fields – is a computed value, which gives list of fields 
			according to the selected SAD/GTD type.
			gtd – represents the link to object with values in the document,
			and is transfered to all sub-instances of form-sad-subitems.

			Recursiveness is required to be able to create columns and subcolumns 
			of inputs on the form.
		-->
    <div class="alert alert-danger" v-if="form_error">
      {{ $t("message.form_has_errors") }}
    </div>
    <form-sad-subitems
      v-if="is_structure_loaded"
      :current_fields="current_fields"
      :gtd="gtd"
      :errors="errors"
    />

    <div
      class="buttons"
      style="position: absolute; bottom: 16px; right: 20%; left: 20px"
    >
      <button
        class="btn btn-outline-success btn-sm dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        :disabled="buttons_loading"
      >
        {{
          $t(
            is_new
              ? "message.contracts.document_create"
              : "message.contracts.document_save",
          )
        }}&nbsp;&nbsp;
        <div
          class="loading loading-button"
          v-if="loading"
          style="
            border-top-width: 2px;
            border-top-color: #4caf50;
            top: 30px;
            right: -93px;
          "
        ></div>
      </button>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <a
          class="dropdown-item"
          style="color: #4caf50"
          @click="saveDocument()"
          :disabled="buttons_loading"
          >{{
            $t(
              is_new
                ? "message.contracts.document_create"
                : "message.contracts.document_save",
            )
          }}</a
        >
      </div>
      <!--<button class="btn btn-success float-left" @click="saveDocument()" :disabled=buttons_loading>{{$t(is_new?'message.contracts.document_create':'message.contracts.document_save')}}</button> -->
    </div>
  </div>
</template>
<script>
var querystring = require("querystring");
import { required } from "vuelidate/lib/validators";
// import FormSadSubitems from './form-sad-subitems.vue'
export default {
  props: ["goods", "contract_details", "document_id", "is_new", "document"],
  // components: {FormSadSubitems},
  data() {
    return {
      errors: [],
      fields: {
        im: [
          {
            //represents row
            id: "row-1",
            items: [
              {
                type: "col",
                id: "col-1",
                classes: "col-md-6",
                items: [
                  {
                    id: "h-0",
                    label: this.$t("message.contracts.sad_line_2"),
                    type: "h",
                    classes: "col-12",
                    is_filled: false,
                  },
                  {
                    id: "gtd_g022i",
                    classes: "col-md-12",
                    type: "text",
                    model: "g022i",
                    label: this.$t("message.contracts.gtd_g022i"),
                    options: {
                      maxlength: 3,
                    },
                  },
                  {
                    id: "gtd_g083",
                    classes: "col-md-12",
                    type: "address",
                    model: "g083",
                    label: this.$t("message.contracts.gtd_g083"),
                    options: {},
                  },
                ],
              },
              {
                type: "col",
                id: "col-2",
                classes: "col-md-3 border p-2",
                items: [
                  {
                    id: "h-1",
                    label: this.$t("message.contracts.sad_line_1_title"),
                    type: "h",
                    classes: "col-12",
                    is_filled: false,
                  },
                  {
                    type: "div",
                    classes: "d-flex px-3 ch-px-3",
                    items: [
                      {
                        id: "gtd_g011",
                        classes: "col-md-4 px-md-0",
                        type: "text",
                        model: "g011",
                        label: this.$t("message.contracts.gtd_g011"),
                        options: {
                          maxlength: 2,
                          noformlabel: true,
                          inputclass:
                            "px-0 text-center rounded-0 rounded-left border-right-0",
                          labelclass:
                            "ultrasmall_underfield  two-line px-2 mt-2 ",
                        },
                      },
                      {
                        id: "gtd_g012",
                        classes: "col-md-4 px-md-0",
                        type: "text",
                        model: "g012",
                        label: this.$t("message.contracts.gtd_g012"),
                        options: {
                          maxlength: 2,
                          noformlabel: true,
                          inputclass: "px-0 text-center rounded-0",
                          labelclass:
                            "ultrasmall_underfield  two-line px-2 mt-2 ",
                        },
                      },
                      {
                        id: "gtd_g012_1",
                        classes: "col-md-4 px-md-0",
                        type: "text",
                        model: "g012_1",
                        label: this.$t("message.contracts.gtd_g012_1"),
                        options: {
                          maxlength: 2,
                          noformlabel: true,
                          inputclass:
                            "px-0 text-center rounded-0 rounded-right border-left-0",
                          labelclass:
                            "ultrasmall_underfield  two-line px-2 mt-2 ",
                        },
                      },
                    ],
                  },
                ],
              },
              {
                type: "col",
                id: "col-3",
                classes: "col-md-3",
                items: [
                  {
                    id: "h-2",
                    label: this.$t("message.contracts.sad_lina_a"),
                    type: "h",
                    classes: "col-12",
                    is_filled: false,
                  },
                  {
                    id: "gtd_ga",
                    classes: "col-md-12",
                    type: "text",
                    model: "ga",
                    label: this.$t("message.contracts.gtd_ga"),
                    options: {
                      maxlength: 14,
                      description: "message.contracts.gtd_g541_doc_num_desc",
                      labelclass: "two-line",
                    },
                  },
                  {
                    id: "gtd_g542",
                    classes: "col-md-12",
                    type: "datepicker",
                    model: "g542",
                    label: this.$t("message.contracts.gtd_g542"),
                    options: {
                      maxlength: 14,
                      labelclass: "two-line",
                    },
                  },
                ],
              },
            ],
            classes: "row",
          },
          {
            id: "row-010",
            items: [
              {
                type: "col",
                id: "col-03",
                classes: "col-md-6 mt-3",
                items: [
                  {
                    type: "h",
                    classes: "col-md-12",
                    id: "h-003",
                    label: "8 всего товаров / 6 всего мест",
                  },
                  {
                    type: "cleave",
                    classes: "col-md-12",
                    id: "gtd_G5",
                    model: "g5",
                    label: "G5",
                    options: {
                      cleave: {
                        numeral: true,
                        numeralPositiveOnly: true,
                        blocks: [20],
                        numeralDecimalScale: 2,
                      },
                    },
                  },
                ],
              },
              {
                type: "col",
                id: "col-03",
                classes: "col-md-6  mt-3",
                items: [
                  {
                    type: "h",
                    classes: "col-md-12",
                    id: "h-004",
                    label: this.$t("message.contracts.sad_line_7"),
                  },
                  {
                    type: "text",
                    id: "gtd_gk_7",
                    required: true,
                    model: "gk_7",
                    classes: "col-12",
                    label: this.$t("message.contracts.gtd_gk_7"),
                    options: {},
                  },
                ],
              },
            ],
          },
          {
            classes: "row mt-2",
            id: "row-2",
            items: [
              {
                type: "col",
                id: "col-4",
                classes: "col-md-6",
                items: [
                  {
                    id: "h-2",
                    label: this.$t("message.contracts.sad_line_8"),
                    type: "h",
                    classes: "col-12",
                    is_filled: false,
                  },
                  {
                    type: "text",
                    id: "gtd_g081",
                    classes: "col-md-6",
                    model: "g081",
                    label: this.$t("message.contracts.gtd_g081"),
                    options: {
                      maxlength: 20,
                    },
                  },
                  {
                    type: "text",
                    id: "gtd_g082",
                    classes: "col-md-6",
                    model: "g082",
                    label: this.$t("message.contracts.gtd_g082"),
                    options: {
                      maxlength: 200,
                      labelclass: "two-line",
                    },
                  },
                  {
                    type: "address",
                    classes: "col-md-12",
                    id: "gtd_g083",
                    model: "g083",
                    label: this.$t("message.contracts.gtd_g083"),
                    options: {},
                  },
                ],
              },
              {
                type: "col",
                id: "col-5",
                classes: "col-md-6",
                items: [
                  {
                    id: "h-2",
                    label: this.$t("message.contracts.sad_line_8"),
                    type: "h",
                    classes: "col-12 text-white",
                    is_filled: false,
                  },
                  {
                    type: "v-select",
                    id: "gtd_g11",
                    required: true,
                    classes: "col-md-12",
                    model: "g11",
                    label: this.$t("message.contracts.gtd_g11"),
                    options: {
                      request: "country",
                    },
                  },
                  {
                    type: "cleave",
                    id: "gtd_g12",
                    classes: "col-md-12",
                    model: "g12",
                    label: this.$t("message.contracts.gtd_g12"),
                    options: {
                      cleave: {
                        numeral: true,
                        numeralPositiveOnly: true,
                        blocks: [20],
                        numeralDecimalScale: 2,
                      },
                    },
                  },
                ],
              },
            ],
          },
          {
            id: "row-3",
            items: [
              {
                type: "col",
                id: "col-6",
                classes: "col-md-6",
                items: [
                  {
                    type: "h",
                    id: "h14",
                    classes: "col-md-12",
                    label: this.$t("message.contracts.sad_line_14"),
                  },
                  {
                    id: "gtd_g0141",
                    model: "g0141",
                    type: "text",
                    classes: "col-md-6",
                    label: this.$t("message.contracts.gtd_g0141"),
                    options: {
                      maxlength: 20,
                    },
                  },
                  {
                    id: "gtd_g0142",
                    model: "g0142",
                    type: "text",
                    classes: "col-md-6",
                    label: this.$t("message.contracts.gtd_g0142"),
                    options: {
                      maxlength: 200,
                      labelclass: "two-line",
                    },
                  },
                  {
                    id: "gtd_g0143",
                    model: "g0143",
                    type: "address",
                    classes: "col-md-12",
                    label: this.$t("message.contracts.gtd_g0143"),
                    options: {
                      maxlength: 200,
                    },
                  },
                ],
              },
              {
                type: "col",
                id: "col-7",
                classes: "col-md-6",
                items: [
                  {
                    type: "h",
                    classes: "col-md-12 text-white",
                    label: this.$t("message.contracts.sad_line_14"),
                  },
                  {
                    type: "v-select",
                    id: "gtd_g116a",
                    classes: "col-md-12",
                    model: "g16a",
                    required: true,
                    label: this.$t("message.contracts.gtd_g16a"),
                    options: {
                      request: "country",
                    },
                  },
                  {
                    type: "v-select",
                    id: "gtd_g15a",
                    required: true,
                    classes: "col-md-6",
                    model: "g15a",
                    label: this.$t("message.contracts.gtd_g15a"),
                    options: {
                      request: "country",
                    },
                  },
                  {
                    type: "v-select",
                    id: "gtd_g17a",
                    required: true,
                    classes: "col-md-6",
                    model: "g17a",
                    label: this.$t("message.contracts.gtd_g17a"),
                    options: {
                      request: "country",
                    },
                  },
                ],
              },
            ],
          },
          {
            id: "row-5",
            items: [
              {
                type: "col",
                id: "col-9",
                classes: "col-md-6",
                items: [
                  {
                    type: "switch",
                    id: "gtd_g19",
                    model: "g19",
                    classes: "col-md-5",
                    label: this.$t("message.contracts.gtd_g19"),
                    options: {
                      choice_1: this.$t("message.no"),
                      choice_2: this.$t("message.yes"),
                    },
                  },
                ],
              },
              {
                type: "col",
                id: "col-10",
                classes: "col-md-6",
                items: [
                  {
                    type: "h",
                    id: "h-13",
                    label: this.$t("message.contracts.sad_line_20"),
                    classes: "col-md-12",
                  },
                  {
                    id: "gtd_g20",
                    model: "g20",
                    type: "cleave",
                    classes: "col-md-6",
                    label: this.$t("message.contracts.gtd_g20"),
                    options: {
                      cleave: {
                        numeral: true,
                        numeralPositiveOnly: true,
                        blocks: [20],
                        numeralDecimalScale: 2,
                      },
                    },
                  },
                  {
                    id: "gtd_g20_incoterms",
                    type: "v-select",
                    model: "g20_incoterms",
                    label: this.$t("message.contracts.gtd_g20_incoterms"),
                    classes: "col-md-6",
                    options: {
                      request: "delivery_term",
                    },
                  },
                  {
                    id: "gtd_g20_place",
                    label: this.$t("message.contracts.gtd_g20_place"),
                    model: "g20_place",
                    type: "text",
                    classes: "col-md-12",
                    options: {
                      maxlength: 200,
                    },
                  },
                ],
              },
            ],
          },
          {
            id: "row-7",
            items: [
              {
                type: "col",
                id: "col-11",
                classes: "col-md-6",
                items: [
                  {
                    type: "h",
                    id: "h-11",
                    label: this.$t("message.contracts.sad_line_21"),
                    classes: "col-md-12",
                  },
                ],
              },
              {
                type: "col",
                id: "col-12",
                classes: "col-md-3",
                items: [
                  {
                    type: "h",
                    id: "h-10",
                    label: this.$t("message.contracts.sad_line_22"),
                    classes: "col-md-12",
                  },
                  {
                    type: "v-select",
                    label: this.$t("message.contracts.gtd_g22_curr"),
                    classes: "col-md-12",
                    id: "gtd_g22_curr",
                    model: "g22_curr",
                    options: {
                      request: "currency",
                    },
                  },
                  {
                    type: "cleave",
                    id: "gtd_gtd_total_price",
                    model: "gtd_total_price",
                    label: this.$t("message.contracts.gtd_gtd_total_price"),
                    classes: "col-md-12",
                    options: {
                      labelclass: "two-line",
                      cleave: {
                        numeral: true,
                        numeralPositiveOnly: true,
                        blocks: [20],
                        numeralDecimalScale: 2,
                      },
                    },
                  },
                ],
              },
              {
                type: "col",
                id: "col-13",
                classes: "col-md-3",
                items: [
                  {
                    type: "h",
                    id: "h-18",
                    label: this.$t("message.contracts.sad_line_23"),
                    classes: "col-md-12",
                  },
                  {
                    type: "cleave",
                    id: "gtd_g23",
                    model: "g23",
                    label: this.$t("message.contracts.gtd_g23"),
                    classes: "col-md-12",
                    options: {
                      readonly: true,
                      cleave: {
                        numeral: true,
                        numeralPositiveOnly: true,
                        blocks: [20],
                        numeralDecimalScale: 2,
                      },
                    },
                  },
                  {
                    type: "h",
                    id: "h-19",
                    classes: "col-md-12",
                    label: this.$t("message.contracts.sad_line_24"),
                  },
                  {
                    type: "v-select",
                    id: "gtd_g241",
                    model: "g241",
                    classes: "col-md-12",
                    label: this.$t("message.contracts.gtd_g241"),
                    options: {
                      request: "nature_of_transaction",
                    },
                  },
                  {
                    type: "v-select",
                    id: "gtd_g221",
                    model: "g242",
                    classes: "col-md-12",
                    label: this.$t("message.contracts.gtd_g242"),
                    options: {
                      request: "attis_payment_types",
                    },
                  },
                ],
              },
            ],
          },
          {
            id: "row-8",
            items: [
              {
                type: "col",
                classes: "col-md-6",
                id: "col-14",
                items: {
                  type: "h",
                  id: "h-21",
                  classes: "col-md-12",
                  label:
                    "25. Вид транспорта / 26. Вид транспорта / 27. Место погрузки-разгрузки",
                },
              },
              {
                type: "col",
                classes: "col-md-6",
                id: "col-15",
                items: {
                  type: "h",
                  id: "h-22",
                  classes: "col-md-12",
                  label: "28. Финансовые и банковские сведения",
                },
              },
            ],
          },
          {
            id: "row-9",
            items: [
              {
                type: "col",
                id: "col-16",
                classes: "col-md-6",
                items: [
                  {
                    type: "h",
                    id: "h-23",
                    classes: "col-md-12",
                    label: "29. Орган въезда/выезда",
                  },
                ],
              },
              {
                type: "col",
                id: "col-17",
                classes: "col-md-6",
                items: [
                  {
                    type: "v-select",
                    id: "gtd_g30_place",
                    label: this.$t("message.contracts.gtd_g30_place"),
                    model: "g30_place",
                    classes: "col-md-12",
                    options: {
                      request: "goods_places",
                    },
                  },
                  {
                    type: "v-select",
                    id: "gtd_g30_twh_code",
                    classes: "col-md-12",
                    label: this.$t("message.contracts.gtd_g30_twh_code"),
                    model: "g30_twh_code",
                    options: {
                      request: "customs_office",
                    },
                  },
                ],
              },
            ],
          },
          {
            type: "row",
            id: "row-10-1",
            items: [
              {
                type: "product-repeater",
                id: "product-repeater-1",
                classes: "col-md-12",
                items: [
                  {
                    id: "row-10",
                    items: [
                      {
                        type: "col",
                        id: "col-18",
                        classes: "col-md-6",
                        items: [
                          {
                            type: "h",
                            id: "h-23",
                            classes: "col-md-12",
                            label: this.$t("message.contracts.sad_line_31"),
                          },
                          {
                            type: "text",
                            id: "gtd_g31_good_name",
                            label: this.$t(
                              "message.contracts.gtd_g31_good_name",
                            ),
                            model: "g31_good_name",
                            classes: "col-md-12",
                            options: {},
                          },
                          {
                            type: "text",
                            id: "gtd_g31_good_rec",
                            label: this.$t(
                              "message.contracts.gtd_g31_good_rec",
                            ),
                            model: "g31_good_rec",
                            classes: "col-md-12",
                            options: {},
                          },
                          {
                            type: "text",
                            id: "gtd_g31_good_data",
                            label: this.$t(
                              "message.contracts.gtd_g31_good_data",
                            ),
                            model: "g31_good_data",
                            classes: "col-md-12",
                            options: {},
                          },
                          {
                            type: "cleave",
                            id: "gtd_g31_cti",
                            model: "g31_cti",
                            classes: "col-md-6",
                            label: this.$t("message.contracts.gtd_g31_cti"),
                            options: {
                              labelclass: "two-line",
                              cleave: {
                                numeral: true,
                                numeralPositiveOnly: true,
                                blocks: [20],
                                numeralDecimalScale: 2,
                              },
                            },
                          },
                          {
                            type: "v-select",
                            id: "gtd_gr31_measure",
                            model: "gr31_measure",
                            label: this.$t(
                              "message.contracts.gtd_gr31_measure",
                            ),
                            classes: "col-md-6",
                            options: {
                              request: "measure",
                            },
                          },
                          {
                            type: "cleave",
                            label: this.$t(
                              "message.contracts.gtd_gr31_place_quant",
                            ),
                            id: "gr31_place_quant",
                            model: "gr31_place_quant",
                            classes: "col-md-12",
                            options: {
                              cleave: {
                                numeral: true,
                                numeralPositiveOnly: true,
                                blocks: [20],
                                numeralDecimalScale: 2,
                              },
                            },
                          },
                          {
                            type: "v-select",
                            id: "gtd_g31_place_type",
                            classes: "col-md-12",
                            label: this.$t(
                              "message.contracts.gtd_g31_place_type",
                            ),
                            model: "g31_place_type",
                            options: {
                              request: "packaging",
                            },
                          },
                          {
                            type: "cleave",
                            label: this.$t(
                              "message.contracts.gtd_g31_container_quant",
                            ),
                            model: "g31_container_quant",
                            id: "g31_container_quant",
                            classes: "col-md-6",
                            options: {
                              labelclass: "two-line",
                              cleave: {
                                numeral: true,
                                numeralPositiveOnly: true,
                                blocks: [20],
                                numeralDecimalScale: 2,
                              },
                            },
                          },
                          {
                            type: "text",
                            label: this.$t(
                              "message.contracts.gtd_g31_proc_conditions",
                            ),
                            id: "g31_proc_conditions",
                            model: "g31_proc_conditions",
                            classes: "col-md-6",
                            options: {},
                          },
                          {
                            type: "v-select",
                            id: "mark_pv",
                            model: "g31_mark",
                            label: this.$t("message.contracts.gtd_g31_mark"),
                            classes: "col-md-6",
                            options: {
                              request: "",
                              indata: [
                                {
                                  value: "pv",
                                  display_text: this.$t(
                                    "message.contracts.gtd_g31_mark_pv",
                                  ),
                                },
                              ],
                            },
                          },
                          {
                            type: "cleave",
                            id: "g31_check_mark",
                            label: this.$t(
                              "message.contracts.gtd_g31_check_mark",
                            ),
                            model: "g31_check_mark",
                            classes: "col-md-6",
                            options: {
                              labelclass: "two-line",
                              cleave: {
                                numeral: true,
                                numeralPositiveOnly: true,
                                blocks: [20],
                                numeralDecimalScale: 2,
                              },
                            },
                          },
                        ],
                      },
                      {
                        type: "col",
                        classes: "col-md-6",
                        id: "col-19",
                        items: [
                          {
                            type: "h",
                            id: "h-25",
                            label: this.$t("message.contracts.sad_line_32"),
                            classes: "col-md-12",
                          },
                          {
                            type: "cleave",
                            classes: "col-md-12",
                            id: "g32_good_num",
                            model: "g32_good_num",
                            label: this.$t(
                              "message.contracts.gtd_g32_good_num",
                            ),
                            options: {
                              cleave: {
                                numeral: true,
                                numeralPositiveOnly: true,
                                blocks: [20],
                                numeralDecimalScale: 2,
                              },
                            },
                          },
                          {
                            type: "h",
                            id: "h-26",
                            label: this.$t("message.contracts.sad_line_33"),
                            classes: "col-md-12",
                          },
                          {
                            type: "tnved",
                            label: this.$t("message.contracts.gtd_g33_tnved"),
                            id: "gtd_g33_tnved",
                            classes: "col-md-12",
                            model: "g33_tnved",
                            options: {
                              name: this.$t("message.tnved_name"),
                              code: this.$t("message.tnved_code"),
                            },
                          },
                          {
                            type: "h",
                            id: "h-27",
                            label: this.$t("message.contracts.sad_line_36"),
                            classes: "col-md-12 mt-2",
                          },
                          {
                            type: "v-select",
                            id: "g36_1",
                            model: "g36_1",
                            label: this.$t("message.contracts.gtd_g36_1"),
                            classes: "col-md-12",
                            options: {
                              request: "cust_dutes_benefits",
                            },
                          },
                          {
                            type: "v-select",
                            id: "g36_2",
                            model: "g36_2",
                            label: this.$t("message.contracts.gtd_g36_2"),
                            classes: "col-md-12",
                            options: {
                              request: "cust_dutes_benefits",
                            },
                          },
                          {
                            type: "v-select",
                            id: "g36_3",
                            model: "g36_3",
                            label: this.$t("message.contracts.gtd_g36_3"),
                            classes: "col-md-12",
                            options: {
                              request: "excise_dutes_benefits",
                            },
                          },
                          {
                            type: "v-select",
                            id: "g36_4",
                            model: "g36_4",
                            label: this.$t("message.contracts.gtd_g36_4"),
                            classes: "col-md-12",
                            options: {
                              request: "vat_benefits",
                            },
                          },
                          {
                            type: "h",
                            id: "h-28",
                            label: this.$t("message.contracts.sad_line_37"),
                            classes: "col-md-12",
                          },
                          {
                            type: "v-select",
                            id: "g37_cust_rej_code",
                            model: "g37_cust_rej_code",
                            label: this.$t(
                              "message.contracts.gtd_g37_cust_rej_code",
                            ),
                            classes: "col-md-12",
                            options: {
                              request: "cust_rej",
                            },
                          },
                          {
                            type: "v-select",
                            id: "g37_good_movement_features_code",
                            model: "g37_good_movement_features_code",
                            label: this.$t(
                              "message.contracts.gtd_g37_good_movement_features_code",
                            ),
                            classes: "col-md-12",
                            options: {
                              request: "goods_movement_features",
                            },
                          },
                          {
                            type: "h",
                            id: "h-29",
                            label: this.$t("message.contracts.sad_line_39"),
                            classes: "col-md-12",
                          },
                          {
                            type: "cleave",
                            classes: "col-md-6",
                            label: this.$t("message.contracts.gtd_g39_quota"),
                            model: "g39_quota",
                            id: "g39_quota",
                            options: {
                              cleave: {
                                numeral: true,
                                numeralPositiveOnly: true,
                                blocks: [20],
                                numeralDecimalScale: 2,
                              },
                            },
                          },
                          {
                            type: "v-select",
                            id: "g39_quota_rest_measure",
                            model: "g39_quota_rest_measure",
                            label: this.$t(
                              "message.contracts.gtd_g39_quota_rest_measure",
                            ),
                            classes: "col-md-6",
                            options: {
                              request: "measure",
                            },
                          },
                          {
                            type: "cleave",
                            classes: "col-md-6",
                            label: this.$t(
                              "message.contracts.gtd_g39_quota_rest",
                            ),
                            model: "g39_quota_rest",
                            id: "g39_quota_rest",
                            options: {
                              cleave: {
                                numeral: true,
                                numeralPositiveOnly: true,
                                blocks: [20],
                                numeralDecimalScale: 2,
                              },
                            },
                          },
                          {
                            type: "v-select",
                            id: "g39_quota_rest_measure",
                            model: "g39_quota_rest_measure",
                            label: this.$t(
                              "message.contracts.gtd_g39_quota_rest_measure",
                            ),
                            classes: "col-md-6",
                            options: {
                              request: "measure",
                            },
                          },
                          {
                            type: "h",
                            id: "h-28",
                            classes: "col-md-12",
                            label: this.$t("message.contracts.sad_line_40"),
                          },
                          {
                            type: "v-select",
                            id: "g40_doc_code",
                            model: "g40_doc_code",
                            label: this.$t(
                              "message.contracts.gtd_g40_doc_code",
                            ),
                            classes: "col-md-12",
                            options: {
                              request: "gtd_doc_codes",
                            },
                          },
                          {
                            type: "text",
                            id: "g40_doc_num",
                            model: "g40_doc_num",
                            label: this.$t("message.contracts.gtd_g40_doc_num"),
                            classes: "col-md-6",
                            options: {
                              labelclass: "two-line",
                            },
                          },
                          {
                            type: "datepicker",
                            id: "g40_doc_date",
                            model: "g40_doc_date",
                            label: this.$t(
                              "message.contracts.gtd_g40_doc_date",
                            ),
                            classes: "col-md-6",
                            options: {
                              labelclass: "two-line",
                            },
                          },
                          {
                            type: "cleave",
                            id: "g40_weight_netto",
                            model: "g40_weight_netto",
                            label: this.$t(
                              "message.contracts.gtd_g40_weight_netto",
                            ),
                            classes: "col-md-12",
                            options: {
                              cleave: {
                                numeral: true,
                                numeralPositiveOnly: true,
                                blocks: [20],
                                numeralDecimalScale: 2,
                              },
                            },
                          },
                          {
                            type: "cleave",
                            id: "g40_quantity",
                            model: "g40_quantity",
                            label: this.$t(
                              "message.contracts.gtd_g40_quantity",
                            ),
                            classes: "col-md-6",
                            options: {
                              cleave: {
                                numeral: true,
                                numeralPositiveOnly: true,
                                blocks: [20],
                                numeralDecimalScale: 2,
                              },
                            },
                          },
                          {
                            type: "v-select",
                            id: "g40_measure",
                            model: "g40_measure",
                            label: this.$t("message.contracts.gtd_g40_measure"),
                            classes: "col-md-6",
                            options: {
                              request: "measure",
                              labelclass: "two-line",
                            },
                          },
                          {
                            type: "tnved",
                            id: "g40_hs_code",
                            model: "g40_hs_code",
                            label: this.$t("message.contracts.gtd_g40_hs_code"),
                            classes: "col-md-12",
                            options: {
                              code: this.$t("message.tnved_code"),
                              name: this.$t("message.tnved_name"),
                            },
                          },
                          {
                            type: "cleave",
                            id: "g40_cost",
                            model: "g40_cost",
                            label: this.$t("message.contracts.gtd_g40_cost"),
                            classes: "col-md-4 mt-3 pr-0",
                            options: {
                              cleave: {
                                numeral: true,
                                numeralPositiveOnly: true,
                                blocks: [20],
                                numeralDecimalScale: 2,
                              },
                            },
                          },
                          {
                            type: "cleave",
                            id: "g40_rate_a",
                            model: "g40_rate_a",
                            label: this.$t("message.contracts.gtd_g40_rate_a"),
                            classes: "col-md-4 mt-3 pr-0",
                            options: {
                              cleave: {
                                numeral: true,
                                numeralPositiveOnly: true,
                                blocks: [20],
                                numeralDecimalScale: 2,
                              },
                            },
                          },
                          {
                            type: "cleave",
                            id: "g40_vat",
                            model: "g40_vat",
                            label: this.$t("message.contracts.gtd_g40_vat"),
                            classes: "col-md-4 mt-3",
                            options: {
                              cleave: {
                                numeral: true,
                                numeralPositiveOnly: true,
                                blocks: [20],
                                numeralDecimalScale: 2,
                              },
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    classes: "row",
                    items: [
                      {
                        type: "col",
                        classes: "col-md-12",
                        id: "col-20",
                        items: [
                          {
                            type: "text",
                            classes: "col-md-4",
                            id: "gtd_g41",
                            model: "g41",
                            label: this.$t("message.contracts.gtd_g41"),
                            options: {},
                          },
                          {
                            type: "cleave",
                            classes: "col-md-4",
                            id: "gtd_g41",
                            model: "g42",
                            label: this.$t("message.contracts.gtd_g42"),
                            options: {
                              cleave: {
                                numeral: true,
                                numeralPositiveOnly: true,
                                blocks: [20],
                                numeralDecimalScale: 2,
                              },
                            },
                          },
                          {
                            type: "text",
                            classes: "col-md-4",
                            id: "gtd_g41",
                            model: "g43",
                            label: this.$t("message.contracts.gtd_g43"),
                            options: {},
                          },
                        ],
                      },
                    ],
                  },
                  {
                    classes: "row",
                    items: [
                      {
                        type: "col",
                        classes: "col-md-12",
                        id: "col-12-g44",
                        items: [
                          {
                            type: "h",
                            id: "h-g44",
                            label: this.$t("message.contracts.sad_line_44"),
                            classes: "col-md-12",
                          },
                          {
                            type: "table",
                            classes: "col-md-12",
                            id: "g44",
                            model: "g44",
                            options: {
                              columns: [
                                {
                                  type: "cleave",
                                  id: "g32_good_num-grid",
                                  label: this.$t(
                                    "message.contracts.gtd_g44_g32_good_num",
                                  ),
                                  model: "g32_good_num",
                                  classes: "col-md-12",
                                  options: {
                                    autoload: (column, index, product) => {
                                      return product.g32_good_num;
                                    },
                                    cleave: {
                                      numeral: true,
                                      numeralPositiveOnly: true,
                                      blocks: [20],
                                      numeralDecimalScale: 2,
                                    },
                                  },
                                },
                                {
                                  type: "v-select",
                                  id: "g44_doc_type_code",
                                  model: "g44_doc_type_code",
                                  label: this.$t(
                                    "message.contracts.gtd_g44_g44_doc_type_code",
                                  ),
                                  classes: "col-md-12",
                                  options: {
                                    request: "gtd_doc_codes",
                                  },
                                },
                                {
                                  type: "text",
                                  id: "g44_serial_doc_num",
                                  model: "g44_serial_doc_num",
                                  label: this.$t(
                                    "message.contracts.gtd_g44_serial_doc_num",
                                  ),
                                  classes: "col-md-12",
                                  options: {
                                    autoload: (field, index) => {
                                      return index + 1;
                                    },
                                  },
                                },
                                {
                                  type: "text",
                                  id: "g44_doc_num",
                                  model: "g44_doc_num",
                                  label: this.$t(
                                    "message.contracts.gtd_g44_doc_num",
                                  ),
                                  classes: "col-md-12",
                                  options: {},
                                },
                                {
                                  type: "datepicker",
                                  id: "g44_doc_date",
                                  model: "g44_doc_date",
                                  label: this.$t(
                                    "message.contracts.gtd_g44_doc_date",
                                  ),
                                  classes: "col-md-12",
                                  options: {},
                                },
                                {
                                  type: "datepicker",
                                  id: "g44_doc_reg_nun",
                                  model: "g44_doc_reg_nun",
                                  label: this.$t(
                                    "message.contracts.gtd_g44_doc_reg_nun",
                                  ),
                                  classes: "col-md-12",
                                  options: {},
                                },
                                {
                                  type: "datepicker",
                                  id: "g44_doc_begin_date",
                                  model: "g44_doc_begin_date",
                                  label: this.$t(
                                    "message.contracts.gtd_g44_doc_begin_date",
                                  ),
                                  classes: "col-md-12",
                                  options: {},
                                },
                                {
                                  type: "datepicker",
                                  id: "g44_doc_end_date",
                                  model: "g44_doc_end_date",
                                  label: this.$t(
                                    "message.contracts.gtd_g44_doc_end_date",
                                  ),
                                  classes: "col-md-12",
                                  options: {},
                                },
                                {
                                  type: "v-select",
                                  id: "g44_doc_sign",
                                  model: "g44_doc_sign",
                                  label: this.$t(
                                    "message.contracts.gtd_g44_doc_sign",
                                  ),
                                  classes: "col-md-12",
                                  options: {
                                    indata: [
                                      {
                                        value: 0,
                                        display_text: this.$t(
                                          "message.contracts.gtd_g44_doc_sign_0",
                                        ),
                                      },
                                      {
                                        value: 1,
                                        display_text: this.$t(
                                          "message.contracts.gtd_g44_doc_sign_1",
                                        ),
                                      },
                                      {
                                        value: 2,
                                        display_text: this.$t(
                                          "message.contracts.gtd_g44_doc_sign_2",
                                        ),
                                      },
                                      {
                                        value: 3,
                                        display_text: this.$t(
                                          "message.contracts.gtd_g44_doc_sign_3",
                                        ),
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    classes: "row",
                    items: [
                      {
                        type: "col",
                        classes: "col-md-6",
                        items: [
                          {
                            type: "h",
                            id: "h-1232",
                            classes: "col-md-12",
                            label: this.$t("message.contracts.sad_line_45"),
                          },
                          {
                            type: "cleave",
                            classes: "col-md-12",
                            id: "g45_customs_value",
                            model: "g45_customs_value",
                            label: this.$t(
                              "message.contracts.gtd_g45_customs_value",
                            ),
                            options: {
                              cleave: {
                                numeral: true,
                                numeralPositiveOnly: true,
                                blocks: [20],
                                numeralDecimalScale: 2,
                              },
                            },
                          },
                        ],
                      },
                      {
                        type: "col",
                        classes: "col-md-6",
                        items: [
                          {
                            type: "h",
                            id: "h-1233",
                            classes: "col-md-12",
                            label: this.$t("message.contracts.sad_line_46"),
                          },
                          {
                            type: "cleave",
                            classes: "col-md-12",
                            id: "g46_stat_value",
                            model: "g46_stat_value",
                            label: this.$t(
                              "message.contracts.gtd_g46_stat_value",
                            ),
                            options: {
                              cleave: {
                                numeral: true,
                                numeralPositiveOnly: true,
                                blocks: [20],
                                numeralDecimalScale: 2,
                              },
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    classes: "row",
                    items: [
                      {
                        type: "col",
                        classes: "col-md-12",
                        id: "col-12-g47",
                        items: [
                          {
                            type: "h",
                            id: "h-g47",
                            label: this.$t("message.contracts.sad_line_47"),
                            classes: "col-md-12",
                          },
                          {
                            type: "table",
                            classes: "col-md-12",
                            id: "g47",
                            model: "g47",
                            options: {
                              columns: [
                                {
                                  type: "v-selec",
                                  id: "g47_cust_pay_code",
                                  label: this.$t(
                                    "message.contracts.gtd_g47_cust_pay_code",
                                  ),
                                  model: "g47_cust_pay_code",
                                  classes: "col-md-12",
                                  options: {
                                    request: "g47_cust_payments",
                                  },
                                },
                                {
                                  type: "text",
                                  id: "g47_accrual_basis",
                                  model: "g47_accrual_basis",
                                  label: this.$t(
                                    "message.contracts.gtd_g47_accrual_basis",
                                  ),
                                  classes: "col-md-12",
                                  options: {},
                                },
                                {
                                  type: "text",
                                  id: "g47_bet_size",
                                  model: "g47_bet_size",
                                  label: this.$t(
                                    "message.contracts.gtd_g47_bet_size",
                                  ),
                                  classes: "col-md-12",
                                  options: {},
                                },
                                {
                                  type: "v-select",
                                  id: "g47_bet_measure",
                                  model: "g47_bet_measure",
                                  label: this.$t(
                                    "message.contracts.gtd_g47_bet_measure",
                                  ),
                                  classes: "col-md-12",
                                  options: {
                                    indata: [
                                      {
                                        value: "percent",
                                        display_text: "%",
                                      },
                                      {
                                        value: "currency",
                                        display_text: this.$t(
                                          "message.contracts.gtd_g47_bet_measure_currency",
                                        ),
                                      },
                                    ],
                                  },
                                },
                                {
                                  type: "cleave",
                                  id: "g47_payment_sum",
                                  model: "g47_payment_sum",
                                  label: this.$t(
                                    "message.contracts.gtd_g47_payment_sum",
                                  ),
                                  classes: "col-md-12",
                                  options: {
                                    cleave: {
                                      numeral: true,
                                      numeralPositiveOnly: true,
                                      blocks: [20],
                                      numeralDecimalScale: 2,
                                    },
                                  },
                                },
                                {
                                  type: "v-select",
                                  id: "g47_pcf_cofe",
                                  model: "g47_pcf_cofe",
                                  label: this.$t(
                                    "message.contracts.gtd_g47_pcf_cofe",
                                  ),
                                  classes: "col-md-12",
                                  options: {
                                    request: "currency",
                                  },
                                },
                              ],
                            },
                          },
                          {
                            type: "h",
                            id: "h-g48",
                            label: this.$t("message.contracts.sad_line_48"),
                            classes: "col-md-12",
                          },
                          {
                            type: "table",
                            classes: "col-md-12",
                            id: "g48",
                            model: "g48",
                            options: {
                              columns: [
                                {
                                  type: "v-select",
                                  id: "g48_cust_pay_code",
                                  label: this.$t(
                                    "message.contracts.gtd_g48_cust_pay_code",
                                  ),
                                  model: "g48_cust_pay_code",
                                  classes: "col-md-12",
                                  options: {
                                    request: "g47_cust_payments",
                                  },
                                },
                                {
                                  type: "text",
                                  id: "g48_doc_number",
                                  model: "g48_doc_number",
                                  label: this.$t(
                                    "message.contracts.gtd_g48_doc_number",
                                  ),
                                  classes: "col-md-12",
                                  options: {
                                    autoload: (field, index) => {
                                      return index + 1;
                                    },
                                  },
                                },
                                {
                                  type: "datepicker",
                                  id: "g48_doc_date",
                                  model: "g48_doc_date",
                                  label: this.$t(
                                    "message.contracts.gtd_g48_doc_date",
                                  ),
                                  classes: "col-md-12",
                                  options: {},
                                },
                                {
                                  type: "datepicker",
                                  id: "g48_payment_date",
                                  model: "g48_payment_date",
                                  label: this.$t(
                                    "message.contracts.gtd_g48_payment_date",
                                  ),
                                  classes: "col-md-12",
                                  options: {},
                                },
                              ],
                            },
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      is_structure_loaded: false,

      buttons_loading: false,
      loading: false,
      add_product: false,
      edit_product: false,
      currently_editing: false,
      form_error: false,
      product_error: false,
      currency_focused: false,
      placeholder_currency: false,
      buyer_focused: false,
      seller_focused: false,
      tnved_focused: false,
      placeholder_tnved: false,
      placeholder_measure: false,
      measure_focused: false,
      country_focused: false,
      currencies: [],
      measures: [],
      companies: [],
      countries: [],
      tnveds: [],
      delivery_terms: [],
      nature_of_transactions: [],
      attis_payment_typeses: [],
      goods_placeses: [],
      currency_rates: [],
      customs_offices: [],
      measures: [],
      packagings: [],

      currencies_conversion: {
        398: "KZT",
        978: "EUR",
        840: "USD",
        156: "CNY",
      },

      g11_focused: false,
      g15a_focused: false,
      g16a_focused: false,
      g17a_focused: false,
      g20_incoterms_focused: false,
      g22_curr_focused: false,
      g241_focused: false,
      g242_focused: false,
      g30_place_focused: false,
      g30_twh_code_focused: false,
      gr31_measure_focused: false,
      g31_place_type_focused: false,

      awb_22c_measure_focus: false,

      cleavePQTY: {
        numeral: false,
        numericOnly: true,
        numeralDecimalScale: 0,
        numeralPositiveOnly: true,
        blocks: [8],
      },
      cleaveWeight: {
        numeral: true,
        // numericOnly: true,
        // numeralDecimalScale: 0,
        numeralPositiveOnly: true,
        blocks: [24],
        numeralDecimalScale: 6,
      },
      cleavePrice: {
        numeral: true,
        numeralPositiveOnly: true,
        blocks: [20],
        numeralDecimalScale: 2,
      },

      gtd: {
        g011: "",
        g012: "",
        g012_1: "",
        g542: "",
        ga: "",
        g5: 1,
        gk_7: "",
        g022i: "",
        g023i: "",
        g081: "",
        g082: "",
        g083: "",
        g0141: "",
        g0142: "",
        g0143: "",
        g11: { value: "" },
        g12: "",
        g15a: { value: "" },
        g16a: { value: "" },
        g17a: { value: "" },
        g19: false,
        g20: "",
        g20_incoterms: { value: "" },
        g20_place: "",
        g22_curr: { value: "" },
        gtd_total_price: "",
        g23: "",
        g241: { value: "" },
        g242: { value: "" },
        g30_place: { value: "" },
        g30_twh_code: { value: "" },
        g041: "",
        g042: "",
        g05: "",
        g06: "",
        sad_line_a: "",
        products: [
          {
            g31_good_name: "",
            g31_good_rec: "",
            g31_good_data: "",
            g31_cti: "",
            gr31_measure: { value: "" },
            gr31_place_quant: "",
            g31_place_type: { value: "" },
            g31_container_quant: "",
            g31_container_num: "",
            g31_proc_conditions: "",
            g31_mark: { value: "" },
            g31_check_mark: "",

            g32_good_num: 1,
            g33_tnved: { value: "" },

            g36_1: { value: "" },
            g36_2: { value: "" },
            g36_3: { value: "" },
            g36_4: { value: "" },
            g37_cust_rej_code: { value: "" },
            g37_good_movement_features_code: { value: "" },

            g39_quota: "",
            g39_quota_measure: { value: "" },
            g39_quota_rest: "",
            g39_quota_rest_measure: { value: "" },

            g40_doc_code: { value: "" },
            g40_doc_num: "",
            g40_doc_date: "",
            g40_weight_netto: "",
            g40_quantity: "",
            g40_measure: { value: "" },
            g40_hs_code: { value: "" },
            g40_cost: "",
            g40_rate_a: "",
            g40_vat: "",

            g41: "",
            g42: "",
            g43: "",
            g44: [],
            //g44: '',
            g45_customs_value: "",
            g46_stat_value: "",
            g47: [],
            g48: [],
            g541_doc_num: "",
            g541_doc_date: "",
            g541_contract_num: "",
            g541_contract_date: "",
            g542_surname: "",
            g542_name: "",
            g542_midlname: "",
            g542_position: "",
            g542_position: "",
            g542_phone: "",
            g542_cert: "",
            g542_doctype: "",
            g542_pass_num: "",
            g542_pass_date: "",
            g543_powers_doc_num: "",
            g543_powers_doc_date: "",
            g543_powers_doc_date_end: "",
          },
        ],
        gb: [],
      },

      Invoice: {
        DocumentNumber: "",
        DocumentDate: "",
        CurrencyCode: "",
        PlacesQuantity: "",
        PlacesDescription: "",
        GrossWeightQuantity: "",
        NetWeightQuantity: "",
        GCost: "",
        Discount: "",
        TransportCharges: "",
        InsuranceCharges: "",
        OtherCharges: "",
        TotalCost: "",
        PaymentPeriod: "",
        InvoiceByer: { value: "" },
        InvoiceSeller: { value: "" },
      },
      InvoiceGoods: [],
      InvoiceGood: {
        GoodMarking: "",
        GoodsCode: { value: "" },
        GoodsDescription: "",
        GoodsQuantity: "",
        SupplementaryQualifierName: { value: "" },
        GrossWeightQuantity: "",
        NetWeightQuantity: "",
        Price: "",
        Discount: "",
        DiscountPercentage: "",
        OriginCountryCode: { value: "" },
        ServiceCharge: "",
        TransportCharges: "",
        OtherCharges: "",
      },
      product_fields: [
        {
          key: "GoodMarking",
          label: this.$t("message.contracts.invoice_products_GoodMarking"),
          sortable: false,
        },
        {
          key: "GoodsCode",
          label: this.$t("message.contracts.invoice_products_GoodsCode"),
          sortable: false,
        },
        {
          key: "Price",
          label: this.$t("message.contracts.invoice_products_Price"),
          sortable: false,
        },
        {
          key: "GoodsQuantity",
          label: this.$t("message.contracts.invoice_products_GoodsQuantity"),
          sortable: false,
        },
        {
          key: "GrossWeightQuantity",
          label: this.$t(
            "message.contracts.invoice_products_GrossWeightQuantity",
          ),
          sortable: true,
        },
        {
          key: "NetWeightQuantity",
          label: this.$t(
            "message.contracts.invoice_products_NetWeightQuantity",
          ),
          sortable: false,
        },
        {
          key: "remove",
          label: "",
        },
      ],
    };
  },
  methods: {
    /**
				Loads document structure from the database
			*/
    load_structure() {
      axios
        .get(window.base + "/document/load_sad_templates")
        .then((response) => {
          this.fields = {};
          response.data.forEach((item) => {
            this.fields[item.form_type] = JSON.parse(item.form_data);
            // console.log('mml', this.fields[item.form_type].items[0].items[0].items[1])
            // this.fields[item.form_type].items[0].items[0].items[1].options.description = 'message.contracts.gtd_g541_doc_num_desc'
          });
          this.is_structure_loaded = true;
        });
    },
    getLibrary(type, query, qty) {
      query = query.toLowerCase();
      axios
        .get(
          window.base +
            "/library?type=" +
            type +
            "&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          var var_name = type;
          if (type[type.length - 1] == "s") {
            var_name = type + "es";
          } else if (type[type.length - 1] == "y") {
            var_name = type.substring(0, type.length - 1) + "ies";
          } else {
            var_name = type + "s";
          }
          this.$data[var_name] = [];
          response.data.forEach((item) => {
            if (item.value !== "··········") this.$data[var_name].push(item);
          });
        });
    },
    fetchCountries(search, loading) {
      this.getLibrary("country", search, 10000);
    },
    fetchCurrencies(search, loading) {
      this.getLibrary("currency", search, 10000);
    },
    fetchDeliveryTerms(search, loading) {
      this.getLibrary("delivery_term", search, 100);
    },
    fetchNatureOfDeals(search, loading) {
      this.getLibrary("nature_of_transaction", search, 100);
    },
    fetchTypeOfCalculations(search, loading) {
      this.getLibrary("attis_payment_types", search, 100);
    },
    fetchTypeOfLocations(search, loading) {
      this.getLibrary("goods_places", search, 100);
    },
    fetchCustomCode(search) {
      this.getLibrary("customs_office", search, 10000);
    },
    fetchMeasures(search) {
      this.getLibrary("measure", search, 10000);
    },
    fetchCurrencyRates() {
      axios.get(window.base + "/library/currency_rates").then((response) => {
        this.currency_rates = response.data;
      });
    },
    fetchPackagings(search, loading) {
      this.getLibrary("packaging", search, 100);
    },
    make_ga(org_custom_code) {
      let date = new Date();
      let year = date.getFullYear().toString();
      axios.get(window.base + "/document/getGTDnumber").then((response) => {
        this.gtd.ga =
          org_custom_code + "1" + year.substring(3, 4) + response.data;
      });
    },
    find_currency_rate(currency) {
      if (currency != "") {
        if (currency == 398) {
          return 1;
        } else {
          let rate =
            this.currency_rates[
              this.currency_rates.findIndex(
                (item) => item.kod == this.currencies_conversion[currency],
              )
            ];
          if (rate && rate.kurs) {
            return rate.kurs;
          }
        }
      }
    },
    load() {
      axios
        .get(window.base + "/Document/LoadGTD/?doc_id=" + this.document_id)
        .then((response) => {
          this.gtd = response.data;
          axios
            .get(
              window.base +
                "/library/country?code=" +
                this.gtd.g11 +
                "&lang=" +
                this.$i18n.locale,
            )
            .then((resp) => {
              this.gtd.g11 = resp.data;
            });
          axios
            .get(
              window.base +
                "/library/country?code=" +
                this.gtd.g15a +
                "&lang=" +
                this.$i18n.locale,
            )
            .then((resp) => {
              this.gtd.g15a = resp.data;
            });
          axios
            .get(
              window.base +
                "/library/country?code=" +
                this.gtd.g16a +
                "&lang=" +
                this.$i18n.locale,
            )
            .then((resp) => {
              this.gtd.g16a = resp.data;
            });
          axios
            .get(
              window.base +
                "/library/country?code=" +
                this.gtd.g17a +
                "&lang=" +
                this.$i18n.locale,
            )
            .then((resp) => {
              this.gtd.g17a = resp.data;
            });
        });
    },
    saveDocument() {
      this.$v.$touch("gtd");
      if (this.$v.gtd.$invalid) {
        this.form_error = true;
        this.errors = [];
        for (let i in this.$v.gtd) {
          if (this.$v.gtd[i] && this.$v.gtd[i].$invalid) {
            this.errors.push(i);
          }
        }
        setTimeout(() => {
          $(".modal").animate(
            { scrollTop: $(".has-danger").eq(0).offset().top - 50 },
            1000,
          );
        }, 100);
      } else {
        this.$root.$emit("show-loading");
        this.buttons_loading = true;

        if (this.is_new) this.gtd.contract_id = this.contract_id;
        else {
          this.gtd.doc_id = this.document_id;
          this.gtd.contract_id = this.contract_id;
        }
        axios
          .post(
            window.base +
              (this.is_new === true
                ? "/Document/CreateGTD?contract_id=" + this.$route.params.id
                : "/Document/UpdateGTD" +
                  "?doc_id=" +
                  this.document_id +
                  "&contract_id=" +
                  this.contract_id),
            this.gtd,
          )
          .then((response) => {
            if (response.data.trim() == "ok") {
              new Noty({
                theme: "light",
                type: "success",
                text: this.$root.$t("message.message.awb-created"),
                timeout: 5000,
              }).show();
              this.$root.$emit("loadDocuments", { category: "all" });
              this.$root.$emit("bv::hide::modal", "modal-document", "#btnShow");
              this.$root.$emit(
                "bv::hide::modal",
                "modal-document-new",
                "#btnShow",
              );
            } else {
              new Noty({
                theme: "light",
                type: "error",
                text:
                  this.$root.$t("message.message.awb-not-created") +
                  " (" +
                  response.data +
                  ")",
                timeout: 5000,
              }).show();
              if (window.dev_mode) {
                this.$root.$emit(
                  "bv::hide::modal",
                  "modal-document",
                  "#btnShow",
                );
                this.$root.$emit(
                  "bv::hide::modal",
                  "modal-document-new",
                  "#btnShow",
                );
              }
            }
          })
          .catch((e) => {
            new Noty({
              theme: "light",
              type: "error",
              text: t1,
              timeout: 5000,
            }).show();
            this.$root.$emit("bv::hide::modal", "modal-document", "#btnShow");
            this.$root.$emit(
              "bv::hide::modal",
              "modal-document-new",
              "#btnShow",
            );
          });
      }
    },
  },
  mounted() {
    // this.fetchCountries('')
    // this.fetchDeliveryTerms('')
    // this.fetchCurrencies('')
    // this.fetchNatureOfDeals('')
    // this.fetchTypeOfCalculations('')
    // this.fetchTypeOfLocations('')
    // this.fetchCurrencyRates()
    // this.fetchCustomCode('')
    // this.fetchMeasures('')
    // this.fetchPackagings('')

    this.load_structure();

    if (this.document_id == "new") {
      //load data from other documents
      let date = new Date();
      this.gtd.g542 = date.toISOString().split("T")[0];
      this.gtd.g012_1 = "ЭД";
      this.gtd.g012 = 40;
      this.gtd.g011 = "ИМ";

      //organizations.org_custom_code

      if (this.$store.state.firmfull == false) {
        axios.get(window.base + "/document/getfirmfull").then((response) => {
          this.$store.commit("load_firm", response.data);
          this.make_ga(response.data.organizations.org_custom_code);
        });
      } else {
        let response = { data: {} };
        response.data = this.$store.state.firmfull;
        this.make_ga(response.data.organizations.org_custom_code);
      }
    } else {
      this.load();
    }
  },
  computed: {
    current_fields() {
      if (this.fields["im"]) return this.fields["im"].items;
      else return [];
    },
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
      }
      return locale;
    },
  },
  watch: {
    gtd: {
      deep: true,
      handler() {
        this.gtd.sad_line_a =
          "1/" + Math.ceil((this.gtd.g05 > 0 ? this.gtd.g05 - 1 : 1) / 3);
        // g22_curr
        this.gtd.g23 = this.find_currency_rate(this.gtd.g22_curr.value);
        if (this.gtd.g5 < this.gtd.products.length)
          this.gtd.products.splice(this.gtd.g5, this.gtd.products.length);
        else if (this.gtd.g5 > this.gtd.products.length) {
          for (let i = 0; i < this.gtd.g5 - this.gtd.products.length; i++)
            this.gtd.products.push({
              g31_good_name: "",
              g31_good_rec: "",
              g31_good_data: "",
              g31_cti: "",
              gr31_measure: { value: "" },
              gr31_place_quant: "",
              g31_place_type: { value: "" },
              g31_container_quant: "",
              g31_container_num: "",
              g31_proc_conditions: "",
              g31_mark: { value: "" },
              g31_check_mark: "",

              g32_good_num: this.gtd.products.length + 1,
              g33_tnved: { value: "" },

              g36_1: { value: "" },
              g36_2: { value: "" },
              g36_3: { value: "" },
              g36_4: { value: "" },
              g37_cust_rej_code: { value: "" },
              g37_good_movement_features_code: { value: "" },

              g39_quota: "",
              g39_quota_measure: { value: "" },
              g39_quota_rest: "",
              g39_quota_rest_measure: { value: "" },

              g40_doc_code: { value: "" },
              g40_doc_num: "",
              g40_doc_date: "",
              g40_weight_netto: "",
              g40_quantity: "",
              g40_measure: { value: "" },
              g40_hs_code: { value: "" },
              g40_cost: "",
              g40_rate_a: "",
              g40_vat: "",

              g41: "",
              g42: "",
              g43: "",
              //g44: '',
              g44: [],
              g45_customs_value: "",
              g46_stat_value: "",
              g47: [],
              g48: [],
            });
        }
      },
    },
  },
  validations() {
    let validation = {
      gtd: {},
    };
    for (let i in this.fields["im"]) {
      let field = this.fields["im"][i];
      for (let j in field.items) {
        let item = field.items[j];
        if (item.type == "col") {
          for (let k in item.items) {
            let citem = item.items[k];
            if (citem.is_required === true) {
              if (citem.type == "v-select") {
                validation.gtd[citem.model] = {
                  value: {
                    required,
                  },
                };
              } else {
                validation.gtd[citem.model] = {
                  required,
                };
              }
            }
          }
        }
      }
      if (field.type == "col") {
        for (let l in field.items) {
          let citem = field.items[l];
          if (citem.required === true) {
            if (citem.type == "v-select") {
              validation.gtd[citem.model] = {
                value: {
                  required,
                },
              };
            } else {
              validation.gtd[citem.model] = {
                required,
              };
            }
          }
        }
      }
    }
    return validation;
  },
};
</script>
<style scoped>
.v-select ul li {
  white-space: break-word !important;
}
</style>
